// src/domain/models/privateMemory.js
/**
 * @fileoverview Manages private data storage for Task instances using WeakMap.
 */
const privateMemory = new WeakMap();

/**
 * Stores the parsed data and related info for a Task instance.
 * @param {Object} instance - The Task instance.
 * @param {Object} data - The data object to store (e.g. { parsed, originalLine }).
 */
export function setPrivateData(instance, data) {
  if (!instance._reference) {
    throw new Error('Object not apt to be used with privateMemory');
  }
  privateMemory.set(instance._reference, data);
}

/**
 * Retrieves the stored data for a Task instance.
 * @param {Object} instance - The Task instance.
 * @returns {Object} - The stored data object.
 * @throws {Error} - Throws if no data is found for the instance.
 */
export function getPrivateData(instance) {
  if (!instance._reference) {
    throw new Error('Object not apt to be used with privateMemory');
  }
  const data = privateMemory.get(instance._reference);
  if (!data) {
    console.error(instance);
    throw new Error('No private data found for the Task instance.');
  }
  return data;
}

export const defineInstanceReference = (instance) => {
  const reference = Object(Symbol(''));
  Object.defineProperty(instance, '_reference', {
    get() {
      return reference;
    }
  });
};
